import '../../../scss/app/project.scss'
